import { NgModule } from '@angular/core';
import { PodsValidationComponent } from './pods-validation.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { PODS_VALIDATION_ROUTES } from './pods-validation.routes';
import { CommonModule } from '@angular/common';
import { PodValidationService } from './shared/pod-validation.service';
import { StickyNavModule } from 'ng2-sticky-nav';
import { PodsValidationListComponent } from './pods-validation-list/pods-validation-list.component';
import { PodsValidationListItemComponent } from './pods-validation-list-item/pods-validation-list-item.component';
import { PodsValidationDocumentComponent } from './pods-validation-document/pods-validation-document.component';
import { PodsValidationStateComponent } from './pods-validation-state/pods-validation-state.component';
import { PodValidationDeliveryItemComponent } from './pod-validation-delivery-item/pod-validation-delivery-item.component';
import { PodsValidationFiltersComponent } from './pods-validation-filters/pods-validation-filters.component';
import { PodValidationDeliveryItemsInputComponent } from './pod-validation-delivery-items-input/pod-validation-delivery-items-input.component';
import { PodValidationProductSelectComponent } from './pod-validation-product-select/pod-validation-product-select.component';
import { PodsValidationDocumentSourceComponent } from './pods-validation-document-source/pods-validation-document-source.component';

@NgModule({
  imports: [
    RouterModule.forChild(PODS_VALIDATION_ROUTES),
    CommonModule,
    SharedModule,
    StickyNavModule,
  ],
  declarations: [
    PodsValidationComponent,
    PodsValidationStateComponent,
    PodsValidationDocumentSourceComponent,
    PodsValidationListComponent,
    PodsValidationListItemComponent,
    PodsValidationDocumentComponent,
    PodValidationDeliveryItemComponent,
    PodsValidationFiltersComponent,
    PodValidationDeliveryItemsInputComponent,
    PodValidationProductSelectComponent
  ],
  providers: [
    PodValidationService,
  ]
})
export class PodsValidationModule {
}
